import NativeAdsService from '@/api/admin/nativeAds.service'

export default {
  state: {
    tableProperties: {
      rows: [],
      searchTerm: '',
    },
    tableMappings: {
      rows: [],
      searchTerm: '',
    },
    nativeAd: {},
  },
  getters: {
    getNativeAd: state => state.nativeAd,
    getNativeAdTableProperties: state => state.tableProperties,
    getNativeAdTableMappings: state => state.tableMappings,
  },
  actions: {
    async getNativeAd({ commit }, id) {
      const nativeAd = await NativeAdsService.getNativeAd(id)
      commit('SET_NATIVE_AD', nativeAd)
    },
  },
  mutations: {
    SET_NATIVE_AD(state, nativeAd) {
      state.nativeAd = nativeAd
      state.tableProperties.rows = nativeAd.properties.filter(property => property.selected === true)
      state.tableMappings.rows = nativeAd.columnMappings
    },
  },
}
